import withAuthPermission from '../../../helpers/withAuthPermission';

const PermissionChecker = (props) => {
    return props.children;
};

export default withAuthPermission(PermissionChecker);
